import { messageRelationships } from "./MessageRelationships.slice";

const actions = messageRelationships.actions;
export { actions as messageRelationshipsActions };
